import React from 'react';
import { useSelector } from 'react-redux';
import { IconButton } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import HomeIcon from '@material-ui/icons/Home';
import SwapHorizontalCircleIcon from '@material-ui/icons/SwapHorizontalCircle';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import ViewListIcon from '@material-ui/icons/ViewList';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import WbIncandescentIcon from '@material-ui/icons/WbIncandescent';

import { ApplicationState } from '../../store';
import Tooltip from '@material-ui/core/Tooltip';
import {
  Container,
  TopIcons,
  BottomIcons,
  useStyles,
} from './LeftMenuStyles';
import AddButton from './AddTrade';

export default function LeftMenu() {
  const classes = useStyles();

  const userState = useSelector((state: ApplicationState) => state.user);

  return (
    <Container className={classes.container}>
      <TopIcons>
        <Tooltip title="Início" placement="right">
          <NavLink to="/" exact activeStyle={{ color: '#ffee58' }} style={{ color: '#fff' }} id="tour-home-btn">
            <IconButton style={{ color: 'inherit' }}>
              <HomeIcon />
            </IconButton>
          </NavLink>
        </Tooltip>
        <Tooltip title="Histórico de trades" placement="right">
          <NavLink to="/history" activeStyle={{ color: '#ffee58' }} style={{ color: '#fff' }} id="tour-history-btn">
            <IconButton style={{ color: 'inherit' }}>
              <ViewListIcon />
            </IconButton>
          </NavLink>
        </Tooltip>
        <Tooltip title="Depósitos e retiradas" placement="right">
          <NavLink to="/depositsAndWithdraws" activeStyle={{ color: '#ffee58' }} style={{ color: '#fff' }} id="tour-deposits-btn">
            <IconButton style={{ color: 'inherit' }}>
              <SwapHorizontalCircleIcon />
            </IconButton>
          </NavLink>
        </Tooltip>
        <Tooltip title="Insights IA" placement="right">
          <NavLink to="/insights" activeStyle={{ color: '#ffee58' }} style={{ color: '#fff' }}>
            <IconButton style={{ color: 'inherit' }}>
              <WbIncandescentIcon />
            </IconButton>
          </NavLink>
        </Tooltip>
        <div id="tour-add-trade">
          <AddButton />
        </div>
      </TopIcons>

      <BottomIcons>
        {userState.user.isAdmin && (
          <Tooltip title="Admin" placement="right">
            <NavLink to="/admin" activeStyle={{ color: '#ffee58' }} style={{ color: '#fff' }}>
              <IconButton style={{ color: 'inherit' }}>
                <SupervisorAccountIcon />
              </IconButton>
            </NavLink>
          </Tooltip>
        )}
        <hr className={classes.hr} />
        <Tooltip title="Suporte" placement="right">
          <a
            rel="noopener noreferrer"
            href="https://api.whatsapp.com/send?phone=5548998155545"
            target="_blank"
          >
            <IconButton>
              <WhatsAppIcon />
            </IconButton>
          </a>
        </Tooltip>
      </BottomIcons>
    </Container>
  );
}
